import React, { useState } from 'react';
import { Alert, Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { CompleteAccountDialog } from './CompleteAccountDialog';

/**
 * Shown to a profile created from Telegram until it has an email and a
 * password. A nudge, not a wall: everything behind it keeps working. Início
 * has its own welcome card, with the fields right there.
 */
export const GuestBanner: React.FC = () => {
  const { t } = useTranslation('auth');
  const { state } = useAuth();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  if (!state.user?.isGuest || pathname === '/dashboard') {
    return null;
  }

  return (
    <>
      <Alert
        severity="info"
        sx={{ mb: 3, borderRadius: 3 }}
        action={
          <Button color="inherit" size="small" onClick={() => setOpen(true)}>
            {t('guest.bannerAction')}
          </Button>
        }
      >
        {t('guest.banner')}
      </Alert>
      <CompleteAccountDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};
